import apiAxios from "../../apiAxios";
import Credentials from "shared/lib/interfaces/Credentials";

export default async function login(credentials: Credentials): Promise<void> {
  await apiAxios.post("/auth/login", credentials);
}
